import React from 'react'

import Style from '../styles/tooltip.css'

class YbTooltip extends React.Component {
  constructor(props) {
    super(props)

    this.hideTooltip = this.hideTooltip.bind(this);
    this.showTooltip = this.showTooltip.bind(this);
    this.toggleTooltip = this.toggleTooltip.bind(this);

    this.state = {
      displayTooltip: false,
    };
  }

  componentDidMount() {
    this.setState({
      renderedComponent: this.refs.container,
    });
  }

  hideTooltip() {
    this.setState({
      displayTooltip: false,
    });
  }

  showTooltip() {
    this.setState({
      displayTooltip: true,
    });
  }

  toggleTooltip() {
    this.setState({
      displayTooltip: !this.state.displayTooltip,
    });
  }

  render() {
    var message = this.props.message;
    var displayTooltip = this.state.displayTooltip;
    var position = this.props.position || 'top';
    var big = this.props.big;
    var extraBig = this.props.extraBig;
    var toggle = this.props.toggle;
    var children = this.props.children;
    var renderedComponent = this.state.renderedComponent;
    var boundingClientRect = null;
    var midPoint = null;
    var angle = 0;

    var tooltipProps = {
      onClick: this.toggleTooltip,
    };
    var triggerProps = {
      onClick: this.toggleTooltip,
    };
    var tooltipMsgProps = {
      style: {},
    };

    if (!toggle) {
      triggerProps.onMouseOver = this.showTooltip;
      triggerProps.onClick = null;
      tooltipProps.onClick = null;
      tooltipProps.onMouseLeave = this.hideTooltip;
    }

    if (position === 'auto' && displayTooltip && renderedComponent) {
      boundingClientRect = renderedComponent.getBoundingClientRect();
      midPoint = {
        x: window.innerWidth / 2,
        y: window.innerHeight / 2,
      };

      angle = Math.atan2(boundingClientRect.x - midPoint.x, boundingClientRect.y - midPoint.y);

      if (angle >= -1*Math.PI/4 && angle < Math.PI/4) {
        position = 'top';
      }
      else if (angle >= Math.PI/4 && angle < Math.PI*(3/4)) {
        position = 'left';
      }
      else if (angle < -1*Math.PI/4 && angle >= -1*Math.PI*(3/4)) {
        position = 'right';
      }
      else {
        position = 'bottom';
      }

    }

    return (
      <span
        ref="container"
        className={Style.tooltip}
        {...tooltipProps}
        >
        {displayTooltip &&
          <div className={`${Style.tooltipBubble} ${Style[position + 'Tooltip']} ${big && Style.bigTooltip} ${extraBig && Style.extraBigTooltip}`}>
            <div className={Style.tooltipMessage} {...tooltipMsgProps}>{message}</div>
          </div>
        }
        <span
          className={Style.tooltipTrigger}
          {...triggerProps}
          >
          {children}
        </span>
      </span>
    )
  }
}

module.exports = YbTooltip;
